module.exports = __webpack_public_path__ + "img/vision.0302ac09.jpg";